import React from "react";
import { Icon } from "../../assets";

const Tag = ({label, size = "small", color = "neutral", icon = null, children, title=null, onClick, style}) => {
    return (
        <span className={"tag tag-"+size+" tag-"+color+(onClick ? ' tag-active' : '')} title={title} onClick={onClick} style={style}><Icon icon={icon} />{children || label}</span>
    )
}

export default Tag